<template>
  <v-row>
    <v-col cols="12" md="4"
      v-for="i in number"
      :key="i"
    >
      <v-skeleton-loader
        type="card"
        class="ma-2 my-4"
      />
    </v-col>
  </v-row>
</template>

<style>
.v-skeleton-loader {
  /*max-width: 374px;*/
  display: inline-block;
  width: 100%;
}
</style>

<script>
export default {
  name: 'SearchSkeletons',
  props: {
    number: {
      type: Number,
      default: 3,
    },
  },
};
</script>
